import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Mission } from '../models/Missions';
import { Observable } from 'rxjs';
import { GeneralData } from '../models/General';
import { catchError, map } from 'rxjs/operators';
import { CollectionResponse, SingleResponse } from '../models/Strapi';
import { WelcomeText } from '../models/WelcomeText';
import { FinishedMissionText } from '../models/FinishedMissionText';
import { AccessCode } from '../models/AccessCodes';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  allMissions: CollectionResponse<Mission>;
  isLoading = false;

  constructor(private http: HttpClient) {}

  getMissions(): Observable<CollectionResponse<Mission>> {
    this.isLoading = true;
    return this.http
      .get<CollectionResponse<Mission>>(
        environment.strapi.strapiApiUrl + '/missions?populate=deep,3&pagination[page]=1&pagination[pageSize]=200')
      .pipe(
        map((missions: CollectionResponse<Mission>) => {
          this.isLoading = false;
          this.allMissions = missions;
          return missions;
        }),
        catchError((error) => {
          this.isLoading = false;
          throw error;
        }),
      );
  }

  getMissionById(id: number): Observable<SingleResponse<Mission>> {
    return this.http.get<SingleResponse<Mission>>(environment.strapi.strapiApiUrl + '/missions/' + id + '?populate=deep,3');
  }

  getMissionsByIds(ids: number[]): Observable<CollectionResponse<Mission>> {
    this.isLoading = true;
    const queryParam = ids.map((id, index) => 'filters[id][$in][' + index + ']=' + id).join('&');

    return this.http
      .get<
        CollectionResponse<Mission>
      >(environment.strapi.strapiApiUrl + '/missions?' + queryParam + '&populate=deep,3&pagination[page]=1&pagination[pageSize]=200')
      .pipe(
        map((missions: CollectionResponse<Mission>) => {
          console.log('missions: ', missions);
          return missions;
        }),
      );
  }

  getGeneral(): Observable<SingleResponse<GeneralData>> {
    return this.http.get<SingleResponse<GeneralData>>(environment.strapi.strapiApiUrl + '/general');
  }

  getWelcomeText(): Observable<CollectionResponse<WelcomeText>> {
    return this.http.get<CollectionResponse<WelcomeText>>(environment.strapi.strapiApiUrl + '/welcome-texts');
  }

  getFinishedMissionsText(): Observable<SingleResponse<FinishedMissionText>> {
    return this.http.get<SingleResponse<FinishedMissionText>>(environment.strapi.strapiApiUrl + '/finished-missions-text');
  }

  getAccessCodes(): Observable<CollectionResponse<AccessCode>> {
    return this.http.get<CollectionResponse<AccessCode>>(environment.strapi.strapiApiUrl + '/access-codes');
  }
}
